// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../node_modules/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../node_modules/react-native-vector-icons/Fonts/AntDesign.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../node_modules/react-native-vector-icons/Fonts/MaterialIcons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../node_modules/react-native-vector-icons/Fonts/Ionicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../node_modules/react-native-vector-icons/Fonts/FontAwesome.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../node_modules/react-native-vector-icons/Fonts/Feather.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../node_modules/react-native-vector-icons/Fonts/Entypo.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../node_modules/react-native-vector-icons/Fonts/EvilIcons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../node_modules/react-native-vector-icons/Fonts/SimpleLineIcons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../node_modules/react-native-vector-icons/Fonts/Octicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../node_modules/react-native-vector-icons/Fonts/Zocial.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../node_modules/react-native-vector-icons/Fonts/Foundation.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../node_modules/react-native-vector-icons/Fonts/FontAwesome6_Solid.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../node_modules/react-native-vector-icons/Fonts/FontAwesome6_Brands.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'MaterialCommunityIcons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'AntDesign';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'MaterialIcons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Ionicons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FontAwesome';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Feather';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Entypo';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'EvilIcons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SimpleLineIcons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Octicons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Zocial';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Foundation';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FontAwesome6_Solid';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FontAwesome6_Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FontAwesome6_Brands';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/web/vector-icons.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,+DAA4G;EAC5G,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAA+F;EAC/F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAmG;EACnG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+DAA8F;EAC9F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+DAAiG;EACjG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA6F;EAC7F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA4F;EAC5F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAA+F;EAC/F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAAqG;EACrG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+DAA8F;EAC9F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA4F;EAC5F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gEAAgG;EAChG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gEAAwG;EACxG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gEAAwG;EACxG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gEAAyG;EACzG,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: 'MaterialCommunityIcons';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'AntDesign';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/AntDesign.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'MaterialIcons';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/MaterialIcons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Ionicons';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/Ionicons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'FontAwesome';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/FontAwesome.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Feather';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/Feather.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Entypo';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/Entypo.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'EvilIcons';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/EvilIcons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'SimpleLineIcons';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/SimpleLineIcons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Octicons';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/Octicons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Zocial';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/Zocial.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Foundation';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/Foundation.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'FontAwesome6_Solid';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/FontAwesome6_Solid.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'FontAwesome6_Regular';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/FontAwesome6_Solid.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'FontAwesome6_Brands';\n  src: url('../../node_modules/react-native-vector-icons/Fonts/FontAwesome6_Brands.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
